var React = require('react');

function ChevronRightInline (props) {
    return React.createElement("svg",props,React.createElement("path",{"fillRule":"evenodd","clipRule":"evenodd","d":"M.366 15.665a1.075 1.075 0 0 1 0-1.616L6.982 8 .366 1.951a1.075 1.075 0 0 1 0-1.616 1.334 1.334 0 0 1 1.768 0l7.5 6.857c.488.446.488 1.17 0 1.616l-7.5 6.857a1.334 1.334 0 0 1-1.768 0Z","fill":"#002F6C"}));
}

ChevronRightInline.defaultProps = {"width":"10","height":"16","viewBox":"0 0 10 16","fill":"none"};

module.exports = ChevronRightInline;

ChevronRightInline.default = ChevronRightInline;
